import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject, effect} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, takeUntil, take, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {HttpErrorResponse} from '@angular/common/http';
import * as _ from 'lodash';
import {CdkConfigService} from '@cdk/services/config.service';
import {CdkSidebarService} from '@cdk/components/sidebar/sidebar.service';
import {navigation} from 'app/navigation/navigation';
import {Router} from '@angular/router';
import {LoginService} from 'app/main/auth/login/login.service';
import {NotificacaoService} from '@cdk/services/notificacao.service';
import {select, Store} from '@ngrx/store';
import * as fromStore from 'app/store';
import {
    ButtonTodasNotificacoesLidas,
    getCounterState,
    getMercureState, ReloadNotificacoes,
    RemoveAllNotificacao,
    RemoveNotificacao
} from 'app/store';
import {Logout} from '../../../main/auth/login/store';
import {Usuario} from '@cdk/models/usuario.model';
import {Notificacao} from '@cdk/models';
import {getIsLoading, getNotificacaoList} from '../../../store';
import {getChatIsLoading} from '../chat-panel/store';
import {ComponenteDigitalService} from '@cdk/services/componente-digital.service';
import {DownloadTemporarioService} from '@cdk/services/download-temporario.service';
import {CdkConfirmDialogComponent} from '@cdk/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DateTime} from 'luxon';
import {DatePipe} from '@angular/common';
import {ShowIfRoleDirective} from '@cdk/directives/show-if-role.directive';
import {BarraPesquisaComponent} from '@cdk/components/barra-pesquisa/barra-pesquisa.component';
import {MatBadge} from '@angular/material/badge';
import {ShepherdComponent} from '../../../../ajuda/tour/tour.component';
import {TitleCasePipe} from '@cdk/pipes/title-case.pipe';
import {SafeResourceUrlPipe} from '@cdk/pipes/safe-resource-url.pipe';
import {AjudaComponent} from '../../../../ajuda/ajuda.component';
import {OperacoesStore} from 'app/store/signals/operacoes.store';
import {format} from 'date-fns';
import {MatToolbar} from '@angular/material/toolbar';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from '@angular/material/tooltip';
import {MatList, MatListItem} from '@angular/material/list';
import {MatDivider} from '@angular/material/divider';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatSnackBar} from '@angular/material/snack-bar';
import {A11yModule} from '@angular/cdk/a11y';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {FormsModule} from '@angular/forms';
import {ChatBotService} from '@cdk/services/chat-bot.service';
import {JuntadasStore} from '../../../main/apps/processo/processo-view/juntadas.store';
import {CdkAccessibilityService} from '@cdk/services/cdk-accessibility.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatToolbar,
        MatIconButton,
        MatIcon,
        ShowIfRoleDirective,
        BarraPesquisaComponent,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        MatTooltip,
        MatBadge,
        MatList,
        MatListItem,
        MatDivider,
        MatProgressSpinner,
        MatCheckbox,
        A11yModule,
        ToggleSwitch,
        FormsModule,
        ShepherdComponent,
        DatePipe,
        TitleCasePipe,
        SafeResourceUrlPipe
    ],
    providers: [
        NotificacaoService,
        AjudaComponent,
    ],
})

export class ToolbarComponent implements OnInit, OnDestroy {
    _cdkConfigService = inject(CdkConfigService);
    _cdkSidebarService = inject(CdkSidebarService);
    private _translateService = inject(TranslateService);
    _loginService = inject(LoginService);
    private _notificacaoService = inject(NotificacaoService);
    private _store = inject<Store<fromStore.State>>(Store);
    private _router = inject(Router);
    private _componenteDigitalService = inject(ComponenteDigitalService);
    private _downloadTemporarioService = inject(DownloadTemporarioService);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _dialog = inject(MatDialog);
    private _matSnackBar = inject(MatSnackBar);
    private _chatBotService = inject(ChatBotService);
    private _accessibilityService = inject(CdkAccessibilityService);
    juntadasStore = inject(JuntadasStore);

    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    userProfile: Usuario;
    notificacoes: Notificacao[] = [];
    notificacoesCount: string;
    carregandoNotificacao = true;
    carregadoNotificacao = false;
    notificacaoIniciaisCarregadas = false;
    carregandoChat: boolean = true;
    totalChatMensagensNaoLidas: any = 0;
    cdkConfig: any;
    checkedNotifications: Notificacao[] = [];
    enableChatBot = false;
    receberNotificacoes = true;

    titulo = 'processo';

    operacoesProcessando = 0;
    operacoesPendentes = 0;

    assinadores: any = [];
    assinadorTime: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    #operacoesStore = inject(OperacoesStore);


    constructor() {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.userProfile = this._loginService.getUserProfile();

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.assinadores = [];
        localStorage.removeItem('assinador');

        effect(() => {
            this.operacoesProcessando = this.#operacoesStore.operacoesEmProcessamentoCount();
            if (this.operacoesProcessando === 0) {
                this.operacoesPendentes = 0;
            } else {
                if (this.operacoesProcessando > this.operacoesPendentes) {
                    this.operacoesPendentes = this.operacoesProcessando;
                }
            }
            this._changeDetectorRef.detectChanges();
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._cdkConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                // Subscribe to config changes
                this.cdkConfig = settings;
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});

        this._store
            .pipe(
                select(getNotificacaoList),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe((notificacoes) => {
                if (notificacoes) {
                    this.notificacoes = notificacoes.sort(((n1,n2) => n2.id - n1.id));
                }
            });
        this._store
            .pipe(
                select(getIsLoading),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe(carregandoNotificacao => this.carregandoNotificacao = carregandoNotificacao);
        this._store
            .pipe(
                select(fromStore.getNotificacaoListLoaded),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe(carregadoNotificacao => {
                this.carregadoNotificacao = carregadoNotificacao
            });
        this._store
            .pipe(
                select(getChatIsLoading),
                takeUntil(this._unsubscribeAll),
            ).subscribe(carregandoChat => this.carregandoChat = carregandoChat);

        this._store
            .pipe(
                select(getCounterState),
                takeUntil(this._unsubscribeAll)
            ).subscribe((value) => {
                if (value && value['notificacoes_pendentes'] !== undefined) {
                    if (parseInt(value['notificacoes_pendentes'], 10) > 99) {
                        this.notificacoesCount = '99+';
                    } else {
                        this.notificacoesCount = value['notificacoes_pendentes'];
                    }
                }

                if (value && value['chat_mensagens_nao_lidas'] !== undefined) {
                    if (parseInt(value['chat_mensagens_nao_lidas'], 10) > 99) {
                        this.totalChatMensagensNaoLidas = '99+';
                    } else {
                        this.totalChatMensagensNaoLidas = value['chat_mensagens_nao_lidas'];
                    }
                }
            }
        );

        this._loginService.getUserProfileChanges()
            .pipe(
                takeUntil(this._unsubscribeAll),
                tap((usuario: Usuario) => {
                    const lotacoes = usuario?.colaborador?.lotacoes ?? [];
                    this.enableChatBot = lotacoes.length > 0;
                }),
                filter(userProfile => !!userProfile)
            )
            .subscribe(userProfile => this.userProfile = userProfile);

        this._loginService.getUserChangedOtherTab().pipe(
            filter(changed => !!changed),
            takeUntil(this._unsubscribeAll)
        ).subscribe((loggedUserChanged) => {
            const dialogRef = this._dialog.open(CdkConfirmDialogComponent, {
                data: {
                    title: 'Mudança de usuário logado detectada',
                    confirmLabel: 'Recarregar',
                    hideCancel: true,
                    message: 'Foi detectada a mudança do usuário autenticado em outra aba do navegador. O sistema precisa ser recarregado.'
                },
                disableClose: true
            });

            dialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
                if (result) {
                    window.location.reload();
                }
            });
        });

        this._store.pipe(
            select(getMercureState),
            takeUntil(this._unsubscribeAll)
        ).subscribe((message) => {
            if (message && message.type === 'assinatura') {
                switch (message.content.action) {
                    case 'ALIVE':
                        const assinadorVersion = localStorage.getItem('assinadorVersion');
                        if (this.compareVersions(message.content.subscriberInfo.version, assinadorVersion)) {
                            this.assinadores = this.assinadores.filter(info => info.processUUID !== message.content.subscriberInfo.processUUID);
                            let selecionado = false;
                            if (this.assinadores.length === 0) {
                                selecionado = true;
                                localStorage.setItem('assinador', message.content.subscriberInfo.processUUID);
                            }
                            this.assinadores.push({
                                timestamp: DateTime.now().toUnixInteger(),
                                selecionado: selecionado,
                                ...message.content.subscriberInfo
                            });
                        }
                        break;
                    case 'DISCONNECTED_NOW':
                        this.assinadores = this.assinadores.filter(info => info.processUUID === message.content.processUUID);
                        if (this.assinadores.length > 0) {
                            let temSelecionado = false;
                            this.assinadores.forEach((ass) => {
                                if (ass.selecionado) {
                                    temSelecionado = true;
                                    localStorage.setItem('assinador', this.assinadores[0].processUUID);
                                }
                            });
                            if (!temSelecionado) {
                                this.assinadores[0].selecionado = true;
                                localStorage.setItem('assinador', this.assinadores[0].processUUID);
                            }
                        } else {
                            localStorage.removeItem('assinador');
                        }
                        break;
                }
            }
        });


        this.loadConfiguracaoNotificacao();

        this.assinadorTime = setInterval(() => {
            const timestamp = DateTime.now().toUnixInteger();
            this.assinadores = this.assinadores.filter(info => (timestamp - info.timestamp) < 15);
            if (this.assinadores.length > 0) {
                let temSelecionado = false;
                this.assinadores.forEach((ass) => {
                    if (ass.selecionado) {
                        temSelecionado = true;
                        localStorage.setItem('assinador', this.assinadores[0].processUUID);
                    }
                });
                if (!temSelecionado) {
                    this.assinadores[0].selecionado = true;
                    localStorage.setItem('assinador', this.assinadores[0].processUUID);
                }
            } else {
                localStorage.removeItem('assinador');
            }
        }, 10000);
    }

    /**
     * Compara a versão do assinador com a versão do backend
     * @param suppVersion
     * @param requiredVersion
     * @return boolean
     */
    compareVersions(suppVersion: string, requiredVersion: string): boolean {
        const [suppMajor, suppMinor, suppRelease] = suppVersion.split('.').map(Number);
        const [requiredMajor, requiredMinor, requiredRelease] = requiredVersion.split('.').map(Number);

        if (suppMajor !== requiredMajor) {
            return false;
        }

        if (suppMinor > requiredMinor) {
            return true;
        }

        if (suppMinor === requiredMinor && suppRelease >= requiredRelease) {
            return true;
        }

        return false;
    }

    setAssinadorSelecionado(assinador): void {
        this.assinadores.forEach((ass) => {
            ass.selecionado = assinador.processUUID === ass.processUUID;
            if (ass.selecionado) {
                if (this.assinadores.length === 0) {
                    localStorage.setItem('assinador', ass.processUUID);
                }
            }
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
        clearInterval(this.assinadorTime);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        if (key === 'ajudaPanel') {
            if (!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen) {
                this._cdkSidebarService.getSidebar('quickPanel').close();
            } else {
                this._cdkSidebarService.getSidebar('quickPanel').fold();
            }
        }
        this._cdkSidebarService.getSidebar(key).toggleOpen();
    }

    toggleQuickPanel(): void {
        const quickPanel = this._cdkSidebarService.getSidebar('quickPanel');
        if (!quickPanel) {
            console.warn('[Toolbar] quickPanel não está registrado. Possível timing issue na inicialização.');
            return;
        }
        if (!quickPanel.isLockedOpen) {
            quickPanel.toggleOpen();
        } else {
            quickPanel.toggleFold();
        }
    }

    toggleChatPanel(): void {
        const chatPanel = this._cdkSidebarService.getSidebar('chatPanel');
        if (!chatPanel) {
            console.warn('[Toolbar] chatPanel não está registrado. Possível timing issue ou usuário sem role ROLE_COLABORADOR.');
            return;
        }
        if (!chatPanel.isLockedOpen) {
            chatPanel.toggleOpen();
        } else {
            chatPanel.toggleFold();
        }
    }

    /**
     * Search
     *
     * @param emissao
     */
    search(emissao): void {
        const chaveAcesso = emissao.chaveAcesso ? '/' + emissao.chaveAcesso : '';
        this._router.navigate(['apps/processo/' + emissao.id + '/visualizar' + chaveAcesso + '/capa']).then(() => {
            if (this._router.url.includes('/capa')) {
                this.juntadasStore.getCapaProcesso();
            }
        });
    }

    goConfiguracoes(): void {
        this._router.navigate(['apps/configuracoes/perfil']);
    }

    goNotificacoes(): void {
        this._router.navigate(['apps/configuracoes/notificacoes']);
    }

    goLogout(): void {
        this._store.dispatch(new Logout({url: false}));
    }

    tour(tour: string): void {
        this.titulo = tour;
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    toggleLida(notificacao: Notificacao): void {
        this._store.dispatch(new fromStore.ToggleLidaNotificacao(notificacao));
    }

    getNotificacaoContext(notificacao: Notificacao): any {
        return notificacao.contexto ? JSON.parse(notificacao.contexto) : false;
    }

    sendToTarget(notificacao: Notificacao): any {
        const contexto = this.getNotificacaoContext(notificacao);
        if (contexto?.processoIdLegado) {
            return this._router.navigate([`/apps/processo/${contexto.processoIdLegado}/visualizar/capa`]);
        }
        switch (notificacao.tipoNotificacao.nome) {
            case 'RELATORIO':
                return this._router
                    .navigate([
                        `/apps/relatorios/administrativo/meus-relatorios/entrada/relatorio/${contexto.id}/visualizar`
                    ]);
            case 'PROCESSO':
            case 'DOWNLOAD PROCESSO':
                const processoIdNav = contexto.processo_id || contexto.id;
                return this._router.navigate([`/apps/processo/${processoIdNav}/visualizar/capa`]);
            case 'TAREFA':
                return this._router
                    .navigate([
                    `/apps/tarefas/administrativo/minhas-tarefas/entrada/tarefa/${contexto.id}/processo/${contexto.id_processo}/visualizar/capa`
                ]);
            default:
                return;
        }
    }

    openNewTab(notificacao: Notificacao): any {
        const contexto = this.getNotificacaoContext(notificacao);
        switch (notificacao.tipoNotificacao.nome) {
            case 'RELATORIO':
                return window.open(`/apps/relatorios/administrativo/meus-relatorios/entrada/relatorio/${contexto.id}/visualizar`);
            case 'PROCESSO':
            case 'DOWNLOAD PROCESSO':
                const processoIdTab = contexto.processo_id || contexto.id;
                return window.open(`/apps/processo/${processoIdTab}/visualizar/capa`);
            case 'TAREFA':
                return window.open(
                        `/apps/tarefas/administrativo/minhas-tarefas/entrada/tarefa/${contexto.id}/processo/${contexto.id_processo}/visualizar/capa`
                );
            default:
                return;
        }
    }

    download(notificacao: Notificacao): void {
        const contexto = this.getNotificacaoContext(notificacao);

        if (contexto?.download_token) {
            this._downloadViaToken(contexto.download_token);
        } else if (contexto?.componente_digital_id) {
            this._downloadViaComponenteDigital(contexto.componente_digital_id);
        }
    }

    /**
     * Novo fluxo — download temporário via token (PDF).
     */
    private _downloadViaToken(token: string): void {
        this._downloadTemporarioService
            .downloadComResponse(token)
            .pipe(take(1))
            .subscribe({
                next: (response) => {
                    const blob = response.body;
                    if (!blob) {
                        return;
                    }
                    const contentDisposition = response.headers.get('Content-Disposition') || '';
                    const filename = this._extractFilename(contentDisposition) || this._fallbackFilename(token, blob.type);

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        link.remove();
                    }, 100);
                },
                error: (error: HttpErrorResponse) => {
                    this._handleDownloadError(error);
                }
            });
    }

    /**
     * Fluxo antigo — download via ComponenteDigital (ZIP e legado).
     */
    private _downloadViaComponenteDigital(componenteDigitalId: number): void {
        this._componenteDigitalService
            .download(componenteDigitalId)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                if (response && response.conteudo) {
                    const byteCharacters = atob(response.conteudo.split(';base64,')[1]);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {type: response.mimetype});
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.download = response.fileName;
                    link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        link.remove();
                    }, 100);
                }
            });
    }

    /**
     * Trata erros HTTP específicos do download temporário.
     */
    private _handleDownloadError(error: HttpErrorResponse): void {
        let mensagem: string;

        switch (error.status) {
            case 410:
                mensagem = 'O download expirou. Gere um novo download.';
                break;
            case 403:
                mensagem = 'Você não tem permissão para acessar este download.';
                break;
            case 404:
                mensagem = 'Arquivo não encontrado no servidor. Gere um novo download.';
                break;
            default:
                mensagem = 'Erro ao realizar o download. Tente novamente.';
                break;
        }

        this._matSnackBar.open(mensagem, 'Fechar', {
            duration: 6000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'snackbar-erro'
        });
    }

    /**
     * Extrai o nome do arquivo do header Content-Disposition.
     */
    private _extractFilename(contentDisposition: string): string | null {
        if (!contentDisposition) {
            return null;
        }
        const utf8Match = contentDisposition.match(/filename\*=(?:UTF-8''|utf-8'')([^;]+)/i);
        if (utf8Match) {
            return decodeURIComponent(utf8Match[1].trim());
        }
        const match = contentDisposition.match(/filename[^;=\n]*=["']?([^"';\n]+)["']?/i);
        return match ? match[1].trim() : null;
    }

    /**
     * Gera um nome de arquivo de fallback baseado no mimetype retornado pelo servidor.
     */
    private _fallbackFilename(token: string, mimetype: string): string {
        const extensionMap: Record<string, string> = {
            'application/pdf': '.pdf',
            'application/zip': '.zip',
            'application/x-zip-compressed': '.zip',
            'application/octet-stream': '',
        };
        const ext = extensionMap[mimetype] ?? '';
        return `processo-${token}${ext}`;
    }

    marcarTodasComoLida(): void {
        this._store.dispatch(new ButtonTodasNotificacoesLidas());
        this._accessibilityService.announce('Todas as notificações marcadas como lidas', 'polite');
    }

    excluirTodasNotificaoes(): void {
        this._store.dispatch(new RemoveAllNotificacao());
        this._accessibilityService.announce('Todas as notificações removidas', 'polite');
    }

    removerNotificacao(notificacao): void {
        this._store.dispatch(new RemoveNotificacao(notificacao.id));
        this._accessibilityService.announce('Notificação removida', 'polite');
    }

    marcarSelecionadosComoLido(): void {
        this.checkedNotifications.forEach((notificacao) => {
            if (!notificacao.dataHoraLeitura) {
                this.toggleLida(notificacao);
            }
        });

        const count = this.checkedNotifications.length;
        this._accessibilityService.announce(`${count} notificação(ões) marcada(s) como lida(s)`, 'polite');
        this.resetSelecoes();
    }

    removerSelecionados(): void {
        const count = this.checkedNotifications.length;
        this.checkedNotifications.forEach((notificacao) => {
            this._store.dispatch(new RemoveNotificacao(notificacao.id));
        });

        this._accessibilityService.announce(`${count} notificação(ões) removida(s)`, 'polite');
        this.resetSelecoes();
    }

    resetSelecoes(): void {
        this.checkedNotifications = [];
    }

    /**
     * @param checked
     * @param notification
     */
    checkNotification(checked: boolean, notification: Notificacao): any {
        if (checked) {
            return this.checkedNotifications.push(notification);
        }

        this.checkedNotifications = this.checkedNotifications.filter(item => item.id !== notification.id);
    }

    reload() {
        this._store.dispatch(new ReloadNotificacoes());
    }

    focusNotificationMenu(): void {
        setTimeout(() => {
            const title = document.querySelector<HTMLElement>('.menuNotificacao #notificacoes-titulo');
            title?.focus();
        });
    }

    loadNotificacoes() {
        if (!this.notificacaoIniciaisCarregadas) {
            this.notificacaoIniciaisCarregadas = true;
            const params = {
                filter: {
                    'destinatario.id': 'eq:' + this._loginService.getUserProfile().id,
                    'lido': 'eq:false',
                    'dataHoraExpiracao': 'gt:' + format(new Date(), 'yyyy-MM-dd\'T\'HH:mm:ss')
                },
                gridFilter: {},
                limit: 10,
                offset: 0,
                sort: {id: 'DESC'},
                populate: ['tipoNotificacao']
            };
            this._store.dispatch(new fromStore.GetNotificacoes(params));
        }
    }

    openChatBotDrawer(): void {
        this._chatBotService.openDrawer();
    }

    toggleReceberNotificacoes(): void {
        this._loginService.setConfiguracao('notificacoes', this.receberNotificacoes)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    }

    private loadConfiguracaoNotificacao(): void {
        const config = this._loginService.getConfiguracao('notificacoes');
        if (config !== null) {
            this.receberNotificacoes = config.valor;
        }
    }
}
